import { StyledAlert } from "App/global-style";
import React from "react";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { useTexts as useFmsTexts } from "Store/texts";
import { isDefined } from "Utils/functions";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import { shouldDisplayAkaRenewalInfoAlert } from "./akaRenewalInfoAlert.helpers";

interface AkaRenewalInfoAlertProps {
  productName?: INSURANCE_NAME_VALUE;
  override?: boolean;
}

export const AkaRenewalInfoAlert = ({
  productName,
  override = false,
}: AkaRenewalInfoAlertProps): React.ReactElement | null => {
  const fmsTexts = useFmsTexts();
  const akaPriceAlertFlag = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_2400_AKA_PRICE_ALERT,
  );

  if (!akaPriceAlertFlag) {
    return null;
  }

  if (
    isDefined(productName) &&
    !shouldDisplayAkaRenewalInfoAlert(productName)
  ) {
    return null;
  }

  if (!isDefined(productName) && !override) {
    return null;
  }

  return (
    <StyledAlert
      title={fmsTexts.domain["akaRenewalInfoAlert.title"]}
      description={fmsTexts.domain["akaRenewalInfoAlert.description"]}
      fluid
    />
  );
};
